module.exports = __webpack_public_path__ + "img/mini-column.d896a6f1.jpg";